import VesselsService from '../../services/VesselsService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';

const SET_VESSELS = 'SET_VESSELS';
const CLEAR_VESSELS = 'CLEAR_VESSELS';

const state = {
  vessels: [],
};

const mutations = {
  [SET_VESSELS](state, vessels) {
    state.vessels = vessels;
  },
  [CLEAR_VESSELS](state) {
    state.vessels = [];
  },
};

const getters = {
  getVessels: (state) => state.vessels,
  getVesselsForSite: (state) => (activeSiteId) => state.vessels
    .filter((x) => x.siteId === activeSiteId),
  getVesselsWithTanks: (state) => state.vessels.filter((x) => x.tanks.length !== 0),
};

const actions = ({
  loadVessels({ commit }, activeSiteId) {
    return VesselsService.getVessels(activeSiteId)
      .then((x) => x.data)
      .then((vesselsData) => {
        commit(SET_VESSELS, vesselsData.vessels);
      });
  },
  createVessel({ dispatch }, vessel) {
    return VesselsService.createVessel(vessel)
      .then((x) => x.data)
      .then((vesselData) => {
        dispatch('loadVessels', vesselData.vessel.siteId);
      }).catch((error) => {
        ErrorHandlerHelpers.handleServiceError(error);
        return error;
      });
  },
  updateVessel({ dispatch }, vesselUpdate) {
    return VesselsService.updateVessel(vesselUpdate)
      .then((x) => x.data)
      .then((vesselData) => {
        dispatch('loadVessels', vesselData.siteId);
      }).catch((error) => {
        ErrorHandlerHelpers.handleServiceError(error);
        return error;
      });
  },
  deleteVessel({ dispatch, rootState }, id) {
    const activeSiteId = rootState.userStore.activeSite
      ? rootState.userStore.activeSite.id
      : rootState.userStore.user.activeSite.id;

    return VesselsService.deleteVessel(id)
      .then((x) => dispatch('loadVessels', activeSiteId))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
